var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login',{attrs:{"titre":"Espace financeur","texte":_vm.description,"login-label":"Identifiant financeur","login-placeholder":"Entrez votre identifiant de financeur","targetPage":"DashboardFinanceur","type":"Membre"},on:{"connect":_vm.connection}})
}
var staticRenderFns = []

export { render, staticRenderFns }